import RebitAccount from "../models/RebitAccount";

const state = {
    rebit_accounts: []
};

const mutations = {
    'SET_REBIT_ACCOUNTS'(state, accounts) {
        state.rebit_accounts = accounts;
    },
};

const actions = {
    set_rebit_accounts: ({commit}) => {
        RebitAccount.list((data) => {
            commit('SET_REBIT_ACCOUNTS', data);
        }).catch(error => {})
    },
};

const getters = {
    rebit_accounts: state => {
        return state.rebit_accounts;
    },
    allRebitAccountsByCurrency: (state) => (acronym) => {
        return state.rebit_accounts.filter(item => item.currency_acronym === acronym)
    },
    activeRebitAccountsByCurrency: (state) => (acronym) => {
        return state.rebit_accounts.filter(item => item.currency_acronym === acronym && item.is_active)
    },
    depositableRebitAccountsByCurrency: (state) => (acronym) => {
        return state.rebit_accounts.filter(item => item.currency_acronym === acronym && item.is_depositable)
    },
    depositableRebitAccounts: (state) => () => {
        return state.rebit_accounts.filter(item => item.is_depositable)
    },
};

export default {
    state,
    mutations,
    actions,
    getters
};
